// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1tWlg","log":"ModalInventoryLogs_log__Nnfxb","date":"ModalInventoryLogs_date__3OWdU","userName":"ModalInventoryLogs_userName__1qZTU"};